import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#2C3E50] text-white py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h4 className="text-lg font-medium mb-4">会社情報</h4>
            <div className="space-y-2 text-gray-300 text-sm">
              <p className="font-medium text-white">おかやま介護認定調査株式会社</p>
              <p>〒700-0000<br />岡山市北区○○町1-2-3</p>
              <p>FAX: 086-012-3457</p>
            </div>
          </div>

          {/* Site Map */}
          <div>
            <h4 className="text-lg font-medium mb-4">サイトマップ</h4>
            <ul className="space-y-3">
              {[
                { name: 'トップページ', path: '/' },
                { name: '会社概要', path: '/about' },
                { name: '事業内容', path: '/service' },
                { name: '採用情報', path: '/recruit' },
                { name: 'お問い合わせ', path: '/contact' }
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-white hover:underline transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-2xl sm:text-3xl font-light mb-4">お問い合わせ</h3>
            <p className="text-gray-300 text-sm mb-6">
              お電話またはフォームから<br />お気軽にご連絡ください
            </p>
            <a
              href="tel:086-012-3456"
              className="text-3xl sm:text-4xl font-bold mb-4 block hover:text-[#5D9B9B] transition-colors duration-300 cursor-pointer"
            >
              086-012-3456
            </a>
            <p className="text-gray-400 text-sm">
              9:00〜18:00(日祝休)
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-600">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm text-center sm:text-left">
              © 2026 おかやま介護認定調査株式会社
            </p>
            <div className="flex items-center gap-6">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 text-sm hover:text-white transition-colors duration-300 cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
